var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _ellipse, _ellipse2, _ellipse3, _path14, _path15, _ellipse4, _path16, _path17;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCoinStacked(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M47.4916 35.9957H0V46.0009H47.4916V35.9957Z",
    fill: "#FFEDC0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M47.6563 36.0808H36.0067V39.3478H47.6563V36.0808Z",
    fill: "#FFA515"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M47.6563 39.3472H36.0067V46.0445H47.6563V39.3472Z",
    fill: "#E07514"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M36.048 38.5287H22.7342V43.7559H36.048V38.5287Z",
    fill: "#FFA515"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M36.0507 43.7174H16.2423V46.0043H36.0507V43.7174Z",
    fill: "#E07514"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8084 43.7174H0V46.0043H19.8084V43.7174Z",
    fill: "#FFA515"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M22.731 38.5287H0V43.7559H22.731V38.5287Z",
    fill: "#FFDC49"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M29.7127 46.0427H0V51.4332H29.7127V46.0427Z",
    fill: "#FFDC49"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M47.6552 46.0427H29.7139V51.4332H47.6552V46.0427Z",
    fill: "#FFA515"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M41.3664 53.6793H11.6537V59.0698H41.3664V53.6793Z",
    fill: "#FFDC49"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M64 53.5934H41.0667V58.926H64V53.5934Z",
    fill: "#FFA515"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M30.0009 51.4341H11.6537V53.6801H30.0009V51.4341Z",
    fill: "#FFA515"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M63.8915 51.4341H29.998V53.6801H63.8915V51.4341Z",
    fill: "#E07514"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 32.1316,
    cy: 23.1292,
    rx: 17.7319,
    ry: 17.7295,
    fill: "#E07514"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 28.3987,
    cy: 21.7295,
    rx: 17.7319,
    ry: 17.7295,
    fill: "#E07514"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 31.4901,
    cy: 24.8205,
    rx: 12.6573,
    ry: 12.6556,
    fill: "#E69B0E"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.3987 39.4591C38.1917 39.4591 46.1306 31.5213 46.1306 21.7295C46.1306 11.9378 38.1917 4 28.3987 4C18.6056 4 10.6667 11.9378 10.6667 21.7295C10.6667 31.5213 18.6056 39.4591 28.3987 39.4591ZM28.2236 34.2102C35.214 34.2102 40.8809 28.5441 40.8809 21.5546C40.8809 14.5651 35.214 8.89895 28.2236 8.89895C21.2331 8.89895 15.5662 14.5651 15.5662 21.5546C15.5662 28.5441 21.2331 34.2102 28.2236 34.2102Z",
    fill: "#FFC11A"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.8664 24.3987C10.7349 23.5281 10.6667 22.6368 10.6667 21.7295C10.6667 11.9378 18.6056 4 28.3987 4C33.578 4 38.2386 6.22026 41.4805 9.76081C40.7754 11.4928 39.8831 13.1287 38.8287 14.6434C36.5694 11.1847 32.6635 8.89895 28.2236 8.89895C21.2331 8.89895 15.5662 14.5651 15.5662 21.5546C15.5662 22.89 15.7731 24.1772 16.1566 25.3857C14.3318 25.2442 12.5615 24.9083 10.8664 24.3987Z",
    fill: "#FFE367"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 21.6909,
    cy: 7.67423,
    rx: 2.0415,
    ry: 2.04123,
    fill: "white"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M24.1403 21.1464L28.8921 9.33996L37.6143 13.3897L32.9751 19.9543L39.5079 23.6286L27.4068 34.2103L24.5487 33.8021L30.6731 24.4124L24.1403 21.1464Z",
    fill: "#E07514"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8744 20.7381L26.1824 7.67423L35.9228 8.90747L30.2653 18.2886L36.7982 21.9628L24.5491 33.802L28.1496 23.9275L20.8744 20.7381Z",
    fill: "#FFE367"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoinStacked);
export default __webpack_public_path__ + "static/media/coin-stacked.087177454b05852b4977e58e0f19449c.svg";
export { ForwardRef as ReactComponent };